import { render, staticRenderFns } from "./viewReview.vue?vue&type=template&id=e18a087e&scoped=true&"
import script from "./viewReview.vue?vue&type=script&lang=js&"
export * from "./viewReview.vue?vue&type=script&lang=js&"
import style0 from "./viewReview.vue?vue&type=style&index=0&id=e18a087e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18a087e",
  null
  
)

export default component.exports